/**
 * @generated SignedSource<<a683600fba641f1e01c768d2937bad17>>
 * @relayHash ab15d6eb5d0035303cb97027578b362c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 92bbbf3ab6fa0ba5e05ac4c042a5b17244743f06f8c95a3e43b527bc8db9bea8

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PlanListOldQuery$variables = {
  cloudId: string;
  currentURL?: AGG$URL | null | undefined;
};
export type PlanListOldQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PlansListOld">;
};
export type PlanListOldQuery = {
  response: PlanListOldQuery$data;
  variables: PlanListOldQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider": isMigratePlanNavRelayEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider: {
    readonly get: () => boolean;
  };
});

import isMigratePlanNavRelayEnabled_provider from '@atlassian/jira-relay-provider/src/migrate-plans-navigation-to-relay.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentURL"
},
v2 = {
  "kind": "Variable",
  "name": "currentURL",
  "variableName": "currentURL"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v7 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "name": "planId"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          },
          {
            "kind": "ScalarField",
            "name": "isReadOnly"
          },
          {
            "kind": "ScalarField",
            "name": "planStatus"
          },
          {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isFavourite"
              },
              (v5/*: any*/)
            ]
          },
          {
            "concreteType": "JiraScenario",
            "kind": "LinkedField",
            "name": "scenario",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "scenarioId"
              },
              (v5/*: any*/)
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "defaultNavigationItem",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "url"
                      }
                    ],
                    "type": "JiraSoftwareBuiltInNavigationItem"
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ],
        "type": "JiraPlan"
      },
      (v6/*: any*/)
    ]
  }
],
v8 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PlanListOldQuery",
    "selections": [
      {
        "args": [
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "PlansListOld"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "PlanListOldQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "favouritePlans",
            "args": [
              (v3/*: any*/),
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "sort": {
                    "order": "DESC"
                  },
                  "type": "PLAN"
                }
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 15
              }
            ],
            "concreteType": "JiraFavouriteConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraFavouriteEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v7/*: any*/)
              },
              (v8/*: any*/)
            ]
          },
          {
            "alias": "recentPlans",
            "args": [
              (v3/*: any*/),
              (v2/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 20
              },
              {
                "kind": "Literal",
                "name": "types",
                "value": [
                  "PLAN"
                ]
              }
            ],
            "concreteType": "JiraSearchableEntityConnection",
            "kind": "LinkedField",
            "name": "recentItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSearchableEntityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v7/*: any*/)
              },
              (v8/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "92bbbf3ab6fa0ba5e05ac4c042a5b17244743f06f8c95a3e43b527bc8db9bea8",
    "metadata": {},
    "name": "PlanListOldQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider": isMigratePlanNavRelayEnabled_provider
    }
  }
};
})();

(node as any).hash = "809278c5b1afade53aa02c70e8136db1";

export default node;
